import React, { useState, useEffect, useRef } from "react";
import "./EqCollapsePanel.scss";
import { Row, Col } from "antd";
import { DownOutlined, UpOutlined } from "@ant-design/icons";

export interface IEqCollapsePanel {
  defaultOpen?: boolean;
  header: React.ReactNode;
  childInnerHeight?: number;
  children?: React.ReactNode;
  classNames?: string;
}

const EqCollapsePanel: React.FC<IEqCollapsePanel> = ({
  defaultOpen = false,
  header,
  children,
  childInnerHeight,
  classNames = ""
}) => {
  const [show, setShow] = useState(defaultOpen);
  const [innerHeight, setInnerHeight] = useState<number | null>(null);
  const ref = useRef<HTMLDivElement>(null);

  const innerStyle: React.CSSProperties = {
    height: show ? 'auto' : '0px',
    overflow: 'hidden',
    transition: 'height 0.3s ease'
  };

  useEffect(() => {
    if (ref.current && ref.current.clientHeight) {
      setInnerHeight(ref.current.clientHeight);
    }
  }, [childInnerHeight, children]); // Added children to dependencies

  const toggleShow = (e: React.MouseEvent) => {
    e.stopPropagation();
    setShow(prev => !prev);
  };

  return (
    <div className="eq-collapse-panel">
      <div 
        onClick={toggleShow}
        role="button"
        aria-expanded={show}
        tabIndex={0}
        className="panel-header-wrapper"
      >
        <Row className={`panel-header ${classNames}`}>
          <Col span={23}>{header}</Col>
          <Col className="arrow" xs={1} sm={1} md={1}>
            <span className="icon">
              {show ? <UpOutlined /> : <DownOutlined />}
            </span>
          </Col>
        </Row>
      </div>

      <div
        ref={ref}
        className="panel-inner"
        style={innerStyle}
        aria-hidden={!show}
      >
        <div className="panel-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default EqCollapsePanel;